<template>
	<select
		class="pr-8"
		:class="[
			'text-gray-900 shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full border-gray-300 rounded-md',
			markInvalid
				? 'text-red-500 border-red-500 border-2 bg-red-100 shadow-sm focus:text-gray-900'
				: '',
		]"
		v-model="val"
	>
		<option v-if="allowEmpty"></option>
		<option v-for="o in options" :key="o.id" :value="o.id">
			{{ __(o.name || o.label) }}
		</option>
	</select>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
		},
		options: {
			type: Array,
			required: true,
		},
		markInvalid: {
			type: Boolean,
			default: false,
		},
		allowEmpty: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			val: this.value,
		};
	},
	watch: {
		val(v) {
			this.$emit("input", v);
			this.$emit("change");
		},
	},
};
</script>
